'use client';

import { GeneralLayout, Menu } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { CategoriesEntity } from '@eliadmin/core/src/api/products/types/product-types';
import { CartHeader } from '@eliadmin/core/src/components/header/cart-header';
import { DefaultHeader } from '@eliadmin/core/src/components/header/default-header';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { usePathname } from 'next/navigation';

export interface HeaderClientProps {
  categories: CategoriesEntity[];
  menu: Menu;
  generalLayout: GeneralLayout['data'];
}

export function HeaderClient({ categories, menu, generalLayout }: HeaderClientProps) {
  const pathname = usePathname();

  const isCartPage = pathname === ROUTES.CART();

  if (isCartPage) {
    return <CartHeader />;
  }

  return <DefaultHeader categories={categories} menu={menu} generalLayout={generalLayout} />;
}
